import axios from "axios";
// import store from "@/store";
// const apiKey = "bdK/XxbJ9ZwWMAF4gwKnIA9rpD8XE6Q4LxF2TjjfHuo=";

const apiKey = "ba03c344-4614-49d8-8994-5e7c7b758b8e";

const httpService = axios.create({
  // baseURL: "http://62.238.48.27:5000/api/",
  baseURL: "https://apitracker.samoza.co.za/api/",
  // baseURL: "https://localhost:7245/api/",

  headers: {
    "Content-Type": "application/json",
    "x-api-key": apiKey,
  },
});

httpService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default httpService;
